export default {"src":"/_next/static/media/profile.e63908de.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};